import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-D_LIh_94.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const CrossOutlinedSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.15158 7.99998L2.66669 3.51518L3.51522 2.66666L8.00011 7.15145L12.4849 2.66666L13.3334 3.51518L8.84864 7.99998L13.3334 12.4847L12.4848 13.3332L8.00011 8.84851L3.51525 13.3333L2.66672 12.4848L7.15158 7.99998Z", fill: "var(--magritte-ui-icon-color)" }) }));
const CrossOutlinedSize16 = hoc(forwardRef(CrossOutlinedSize16Component), 'CrossOutlinedSize16');

export { CrossOutlinedSize16 as default };
//# sourceMappingURL=CrossOutlinedSize16.js.map
